/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestAccountDelete.defs.js'
export * as $defs from './requestAccountDelete.defs.js'
